import React, { Component } from 'react';
import ProjectGallery from './ProjectGallery';
import './Project.css';

export default class Project extends Component {
  state = {
    hovering: false,
    montageIndex: 0,
    galleryOpen: false,
    galleryIndex: 0,
  };

  montageTimer = null;

  get images() {
    return (this.props.project.media || []).filter(m => m.type === 'image');
  }

  handleMouseEnter = () => {
    const { video } = this.props.project;
    this.setState({ hovering: true, montageIndex: 1 });

    if (!video && this.images.length > 1) {
      this.montageTimer = setInterval(() => {
        this.setState(prev => ({
          montageIndex: (prev.montageIndex + 1) % this.images.length,
        }));
      }, 900);
    }
  };

  handleMouseLeave = () => {
    this.setState({ hovering: false, montageIndex: 0 });
    if (this.montageTimer) {
      clearInterval(this.montageTimer);
      this.montageTimer = null;
    }
  };

  handleThumbnailClick = () => {
    const { media } = this.props.project;
    if (media && media.length > 0) {
      this.setState({ galleryOpen: true, galleryIndex: 0 });
    }
  };

  handleGalleryClose = () => {
    this.setState({ galleryOpen: false });
  };

  handleGalleryNavigate = (index) => {
    this.setState({ galleryIndex: index });
  };

  componentWillUnmount() {
    if (this.montageTimer) {
      clearInterval(this.montageTimer);
    }
  }

  renderThumbnail() {
    const { thumbnail, video, media, lightBg, thumbnailPosition } = this.props.project;
    const { hovering, montageIndex } = this.state;
    const objPos = thumbnailPosition ? { objectPosition: thumbnailPosition } : {};
    const hasMedia = media && media.length > 0;

    if (!thumbnail && !hasMedia) {
      return (
        <div className="project-thumbnail project-thumbnail-placeholder" />
      );
    }

    const hasHoverEffect = video || this.images.length > 1;
    const classes = ['project-thumbnail'];
    if (hasMedia) classes.push('project-thumbnail-clickable');
    if (lightBg) classes.push('project-thumbnail-light');

    return (
      <div
        className={classes.join(' ')}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.handleThumbnailClick}
      >
        {thumbnail && (
          <img
            className="thumbnail-image"
            src={thumbnail}
            alt=""
            style={{ opacity: hovering && hasHoverEffect ? 0 : 1, ...objPos }}
          />
        )}

        {hovering && video && (
          <video
            className="thumbnail-video"
            autoPlay
            muted
            loop
            playsInline
            style={objPos}
          >
            {video.webm && <source src={video.webm} type="video/webm" />}
            <source src={video.mp4} type="video/mp4" />
          </video>
        )}

        {!video && this.images.length > 1 && this.images.map((img, i) => (
          <img
            key={i}
            className="thumbnail-montage"
            src={img.thumb || img.src}
            alt=""
            style={{ opacity: hovering && i === montageIndex ? 1 : 0, ...objPos }}
          />
        ))}

        {video && !hovering && (
          <div className="thumbnail-play-hint">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        )}

        {hasMedia && media.length > 1 && (
          <span className="thumbnail-badge">{media.length}</span>
        )}
      </div>
    );
  }

  render() {
    const { name, role, url, description, media } = this.props.project;
    const { galleryOpen, galleryIndex } = this.state;

    return (
      <div className="project">
        {this.renderThumbnail()}
        <div className="project-info">
          <div className="project-header">
            {url ? (
              <a href={url} target="_blank" rel="noopener noreferrer" className="project-name">
                {name}
              </a>
            ) : (
              <span className="project-name">{name}</span>
            )}
            <span className="project-role">{role}</span>
          </div>
          {this.props.project.urlText && (
            <a href={url} target="_blank" rel="noopener noreferrer" className="project-url-text">{this.props.project.urlText}</a>
          )}
          <p className="project-description">{description}</p>
        </div>
        {galleryOpen && media && media.length > 0 && (
          <ProjectGallery
            media={media}
            index={galleryIndex}
            onNavigate={this.handleGalleryNavigate}
            onClose={this.handleGalleryClose}
          />
        )}
      </div>
    );
  }
}
